import type { IComponentOptions, IControllerConstructor, Injectable } from "angular";
import { module } from "angular";
import "./EditMotionDetectionFunctionality.html";
import "./EditMotionDetectionFunctionality.scss";

import EditMotionDetectionFunctionalityComponentController from "./EditMotionDetectionFunctionalityComponentController";

export default class EditMotionDetectionFunctionalityComponent implements IComponentOptions {
    public bindings: any;

    public controller: Injectable<IControllerConstructor>;

    public templateUrl: string;

    public transclude: boolean;

    constructor() {
        this.bindings = {
            resolve: "<",
        };
        this.controller = EditMotionDetectionFunctionalityComponentController;

        this.templateUrl =
            "/App/Components/Site/DesignAndPlanning/SelectedEquipment/" +
            "CameraConfigurations/EditMotionDetectionFunctionality/EditMotionDetectionFunctionality.html";

        this.transclude = true;
    }
}

module("mmManagePortal").component(
    "irEditMotionDetectionFunctionality",
    new EditMotionDetectionFunctionalityComponent(),
);
